import React from 'react';

import AppSidebar from '../../../../../../base/components/layout/app-sidebar';

const HeaderMenu = () => <AppSidebar />;

export default HeaderMenu;
